const $spacer = $('#header-spacer');
const $header = $('#header');
const $nav = $('#nav');
const $dropdown = $('.dropdown');
const $dropdownMenu = $('.dropdown-menu');

$DOC.ready(() => {
	// Add/remove burger animation class
	$nav.on('show.bs.collapse', function() {
		$('.navbar-toggler').addClass('is-active');
	});

	$nav.on('hide.bs.collapse', function() {
		$('.navbar-toggler').removeClass('is-active');
	});

	// Add slideUp/slideDown animation to dropdowns
	$dropdown.on('show.bs.dropdown', function() {
		if (window.matchMedia('(min-width: 992px)').matches) return;

		$(this)
			.find('.dropdown-menu')
			.first()
			.stop(true, true)
			.slideDown();
	});

	$dropdown.on('hide.bs.dropdown', function() {
		if (window.matchMedia('(min-width: 992px)').matches) return;

		$(this)
			.find('.dropdown-menu')
			.first()
			.stop(true, true)
			.slideUp();
	});
});

$WINDOW.on('resize', () => {
	$dropdownMenu.attr('style', '').removeClass('show');
});

$WINDOW.on('scroll', () => {
	var scrollTop = $(window).scrollTop();

	if (scrollTop > 100) {
		$header.addClass('-scrolled');
		$spacer.addClass('-scrolled');
	} else {
		$header.removeClass('-scrolled');
		$spacer.removeClass('-scrolled');
	}
});
